import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateDesignatedUnitModalService } from '../../services/create-designated-unit-modal.service';
import { TypeService } from '../../../../../../../../services/type/type-service';

@Component({
  selector: 'app-create-designated-unit-general-details-step',
  templateUrl: './create-designated-unit-general-details-step.component.html',
  styleUrls: ['./create-designated-unit-general-details-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitGeneralDetailsStepComponent {
  private flowService = inject(CreateDesignatedUnitModalService);
  private ngbActiveModal = inject(NgbActiveModal);
  private typeService = inject(TypeService);

  public designatedUnitTypeDropdowns$ = this.typeService.designatedUnitTypes$.baseTypeToDropdowns();
  public remittanceFrequencyDropdowns$ = this.typeService.remittanceFrequencyTypes$.baseTypeToDropdowns();

  public formGroup = this.flowService.designatedUnitForm;
  public formSubmitted: boolean = false;

  public cancel(): void {
    this.ngbActiveModal.close();
  }

  public continue(): void {
    this.formSubmitted = true;
    if (this.formGroup.controls.generalDetails.invalid) return;
    this.flowService.goForward();
  }
}
